var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    { staticClass: "demo-ruleForm", attrs: { model: _vm.servcWorkVoucher } },
    [
      _c(
        "div",
        { staticClass: "block-container" },
        [
          _vm.dbServcWorkVoucher.deviceFlag
            ? [
                _c("div", { staticClass: "content-caption dashed bg-white" }, [
                  _c("span", [_vm._v("设备信息")])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "simple-form" }, [
                  _c("div", { staticClass: "form-group center" }, [
                    _c("div", { staticClass: "form-label" }, [
                      _c("label", [_vm._v("设备名称")])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-value" }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.dbServcWorkVoucher.devcTitle))
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group center" }, [
                    _c("div", { staticClass: "form-label" }, [
                      _c("label", [_vm._v("设备分类")])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-value" }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.dbServcWorkVoucher.devcCatName))
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group center" }, [
                    _c("div", { staticClass: "form-label" }, [
                      _c("label", [_vm._v("设备品牌")])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-value" }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.dbServcWorkVoucher.deviceBrandName))
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group center" }, [
                    _c("div", { staticClass: "form-label" }, [
                      _c("label", [_vm._v("设备编号")])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-value" }, [
                      _c("span", [_vm._v(_vm._s(_vm.dbServcWorkVoucher.tmpNo))])
                    ])
                  ])
                ])
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.servcWorkVoucher.comnRepairFlag
            ? [
                _c("div", { staticClass: "content-caption dashed bg-white" }, [
                  _c("span", [_vm._v("服务项目")])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "simple-form" }, [
                  _c("div", { staticClass: "form-group center" }, [
                    _c("div", { staticClass: "form-label " }, [
                      _c("label", { staticClass: "required" }, [
                        _vm._v("服务项目")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-value" }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.servcWorkVoucher.comnRepairTitle))
                      ])
                    ])
                  ])
                ])
              ]
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "content-caption dashed" }, [
            _c("span", [_vm._v("服务商")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "simple-form" }, [
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label " }, [
                _c("label", { staticClass: "required" }, [_vm._v("服务商")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "servicerName" } },
                    [
                      _c("el-input", {
                        staticClass: "width-2x bottom-line",
                        attrs: { disabled: true },
                        model: {
                          value: _vm.servcWorkVoucher.servicerName,
                          callback: function($$v) {
                            _vm.$set(_vm.servcWorkVoucher, "servicerName", $$v)
                          },
                          expression: "servcWorkVoucher.servicerName"
                        }
                      }),
                      _vm._v(" "),
                      _c("i", {
                        staticClass:
                          "icon iconfont icon-chazhaobiaodanliebiao relation-icon",
                        on: { click: _vm.selectServicer }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "content-caption dashed bg-white" }, [
            _c("span", [_vm._v("服务信息")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "simple-form" }, [
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", [_vm._v("服务类型")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-value" }, [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.workServcTypeMap[_vm.dbServcWorkVoucher.servcType]
                    )
                  )
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "simple-form" }, [
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", [_vm._v("紧急状态")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value width-2x" },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择" },
                      model: {
                        value: _vm.servcWorkVoucher.emgLevel,
                        callback: function($$v) {
                          _vm.$set(_vm.servcWorkVoucher, "emgLevel", $$v)
                        },
                        expression: "servcWorkVoucher.emgLevel"
                      }
                    },
                    _vm._l(_vm.emgLevelList, function(emgLevel) {
                      return _c("el-option", {
                        key: emgLevel.value,
                        attrs: { label: emgLevel.text, value: emgLevel.value }
                      })
                    })
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label " }, [
                _c("label", { staticClass: "required" }, [_vm._v("服务")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value" },
                [
                  _c("el-input", {
                    staticClass: "width-2x bottom-line",
                    attrs: { disabled: true },
                    model: {
                      value: _vm.servcWorkVoucher.servcTitle,
                      callback: function($$v) {
                        _vm.$set(_vm.servcWorkVoucher, "servcTitle", $$v)
                      },
                      expression: "servcWorkVoucher.servcTitle"
                    }
                  }),
                  _vm._v(" "),
                  _c("i", {
                    staticClass:
                      "icon iconfont icon-chazhaobiaodanliebiao relation-icon",
                    on: { click: _vm.selectServc }
                  })
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "content-caption dashed" }, [
            _c("span", [_vm._v("其他信息")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "simple-form" }, [
            _vm.showBasicClaim
              ? _c("div", { staticClass: "form-group center" }, [
                  _c("div", { staticClass: "form-label" }, [
                    _c("label", [_vm._v("价格质量要求")])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-value width-2x" },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择" },
                          on: { change: _vm.selectBasicClaim },
                          model: {
                            value: _vm.basicClaimIndex,
                            callback: function($$v) {
                              _vm.basicClaimIndex = $$v
                            },
                            expression: "basicClaimIndex"
                          }
                        },
                        _vm._l(_vm.servcBasicClaimList, function(
                          basicClaim,
                          index
                        ) {
                          return _c("el-option", {
                            key: basicClaim.id,
                            attrs: {
                              label: basicClaim.goodsModel,
                              value: index
                            }
                          })
                        })
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [_vm._v("上门费")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value" },
                [
                  _c("el-input", {
                    staticClass: "width-2x",
                    model: {
                      value: _vm.servcWorkVoucher.toDoorFee,
                      callback: function($$v) {
                        _vm.$set(_vm.servcWorkVoucher, "toDoorFee", $$v)
                      },
                      expression: "servcWorkVoucher.toDoorFee"
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("分钟")])
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [_vm._v("服务费")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value" },
                [
                  _c("el-input", {
                    staticClass: "width-2x",
                    model: {
                      value: _vm.servcWorkVoucher.generallFee,
                      callback: function($$v) {
                        _vm.$set(_vm.servcWorkVoucher, "generallFee", $$v)
                      },
                      expression: "servcWorkVoucher.generallFee"
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("分钟")])
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [
                  _vm._v("要求响应时长")
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value" },
                [
                  _c("el-input", {
                    staticClass: "width-2x",
                    model: {
                      value: _vm.servcWorkVoucher.yqRspTimeMi,
                      callback: function($$v) {
                        _vm.$set(_vm.servcWorkVoucher, "yqRspTimeMi", $$v)
                      },
                      expression: "servcWorkVoucher.yqRspTimeMi"
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("分钟")])
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [
                  _vm._v("要求到达时长")
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value" },
                [
                  _c("el-input", {
                    staticClass: "width-2x",
                    on: { change: _vm.yqArriveTimeMiChange },
                    model: {
                      value: _vm.servcWorkVoucher.yqArriveTimeMi,
                      callback: function($$v) {
                        _vm.$set(_vm.servcWorkVoucher, "yqArriveTimeMi", $$v)
                      },
                      expression: "servcWorkVoucher.yqArriveTimeMi"
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("分钟")])
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [
                  _vm._v("要求完成时长")
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value" },
                [
                  _c("el-input", {
                    staticClass: "width-2x",
                    model: {
                      value: _vm.servcWorkVoucher.yqRepairedTimeMi,
                      callback: function($$v) {
                        _vm.$set(_vm.servcWorkVoucher, "yqRepairedTimeMi", $$v)
                      },
                      expression: "servcWorkVoucher.yqRepairedTimeMi"
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("分钟")])
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [
                  _vm._v("要求回询时限")
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value" },
                [
                  _c("el-input", {
                    staticClass: "width-2x",
                    attrs: { min: "0" },
                    model: {
                      value: _vm.servcWorkVoucher.reqTelCallTimeMi,
                      callback: function($$v) {
                        _vm.$set(_vm.servcWorkVoucher, "reqTelCallTimeMi", $$v)
                      },
                      expression: "servcWorkVoucher.reqTelCallTimeMi"
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("分钟")])
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [_vm._v("预约时间")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value width-2x" },
                [
                  _c("el-date-picker", {
                    staticClass: "width-2x",
                    attrs: {
                      clearable: false,
                      type: "datetime",
                      placeholder: "选择预约时间",
                      format: "yyyy-MM-dd HH:mm"
                    },
                    model: {
                      value: _vm.servcWorkVoucher.planTime,
                      callback: function($$v) {
                        _vm.$set(_vm.servcWorkVoucher, "planTime", $$v)
                      },
                      expression: "servcWorkVoucher.planTime"
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [_vm._v("情况描述")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value width-2x" },
                [
                  _c("el-input", {
                    attrs: { type: "textarea" },
                    model: {
                      value: _vm.servcWorkVoucher.troubleDesc,
                      callback: function($$v) {
                        _vm.$set(_vm.servcWorkVoucher, "troubleDesc", $$v)
                      },
                      expression: "servcWorkVoucher.troubleDesc"
                    }
                  })
                ],
                1
              )
            ])
          ])
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6a71d1ba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a71d1ba","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/workVoucher/ServcWorkVoucherCopySave.vue
// module id = 2859
// module chunks = 0